<template>
  <div>
    <form @submit.prevent="submitForm">
      <div class="card">
        <div class="card-header bg-custom">
          <h2 class="card-title">NACTA Client</h2>
        </div>

        <div class="card-body">

          <div class="row">
            <div class="col-md-4">
              <label>SRO NO</label>
              <input type="text" class="form-control" v-model="mainForm.SRO_NO" maxlength="25" pattern="^[a-zA-Z0-9\/\-\s]{1,25}$" required />
            </div>
            <div class="col-md-4">
              <label>Date</label>
              <input type="date" class="form-control" v-model="mainForm.DATE_OF_SCR" required />
            </div>
            <div class="col-md-1">
              <br />
              <button type="button" class="btn btn-primary" @click="openModal(null)">Add New</button>
            </div>
            <div class="col-md-3">
              <br />
              <button type="button" class="btn btn-primary" @click="openImportModal">Import File</button>
            </div>
          </div>

          <table class="table table-bordered mt-3">
            <thead class="bg-custom">
              <tr>
                <th>Sr. No</th>
                <th>Partner Type</th>
                <th>Name</th>
                <th>Father Name</th>
                <th>CNIC</th>
                <th>SRO NO</th>
                <th>Date</th>
                <th>Delete From Black List By</th>
                <th>Status</th>
                <!--<th>Active</th>-->
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in detailList" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.PTR_TYPE }}</td>
                <td>{{ item.CLIENT_NAME }}</td>
                <td>{{ item.FATHERNAME }}</td>
                <td>{{ item.CNIC_NO }}</td>
                <td>{{ item.SRO_NO }}</td>
                <td>{{ item.DATE_OF_SCR }}</td>
                <td>{{ item.BLACK_LIST_BY }}</td>
                <td>{{ getStatusText(item.STATUS) }}</td>
                <!--<td>
                <input type="checkbox" :checked="item.ACTIVE" disabled />
              </td>-->
                <td>
                  <button type="button" class="btn btn-primary btn-sm" @click="editRow(index)">Edit</button>
                  <button type="button" class="btn btn-danger btn-sm ml-1" @click="deleteRow(index)">Delete</button>
                </td>
              </tr>
              <tr v-if="detailList.length === 0">
                <td colspan="8" class="text-center text-muted">
                  No entries yet. Click "Add New" to begin.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-success float-right mr-1" :disabled="detailList.length === 0">
            Save All
          </button>
          <a class="btn btn-primary" href="../UIC/BlockAccountsClientList">Back to List</a>
        </div>
      </div>
    </form>

    <div class="modal fade" id="clientModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">

          <div class="modal-header bg-custom">
            <h5 class="modal-title">{{ editingIndex !== null ? 'Edit List' : 'Add List' }}</h5>
            <button type="button" class="close" @click="closeModal">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="form-group col-md-4">
                <label class="form-label">Partner Type</label>
                <v-select placeholder="--Select--" label="Title" :options="partnerTypes" v-model="form.PTR_ID" :reduce="x=>x.ID" />
              </div>
              <div class="form-group col-md-4">
                <label>Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model.trim="form.CLIENT_NAME" />
              </div>

              <div class="form-group col-md-4">
                <label>Father Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model.trim="form.FATHERNAME" />
              </div>

              <div class="form-group col-md-4">
                <label>CNIC <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-mask="'#############'" v-model="form.CNIC_NO" placeholder="13-digit CNIC" />
              </div>

              <div class="form-group col-md-4">
                <label>Province</label>
                <v-select label="Title" :options="states" v-model="form.PVN_ID" :reduce="x => x.ID" placeholder="-- Select Province --" @input="fetchCities" />
              </div>

              <div class="form-group col-md-4">
                <label>District</label>
                <v-select label="Title" :options="cities" v-model="form.CTY_ID" :reduce="x => x.ID" placeholder="-- Select District --" />
              </div>

              <div class="form-group col-md-4">
                <label>Delete From Black List By</label>
                <input type="text" class="form-control" v-model.trim="form.BLACK_LIST_BY" />
              </div>

              <div class="form-group col-md-4">
                <label>SECP Email Date</label>
                <input type="date" class="form-control" v-model="form.SECP_EMAIL_DATE" />
              </div>

              <div class="form-group col-md-4">
                <label>Status <span class="text-danger">*</span></label>
                <select class="form-control" v-model="form.STATUS">
                  <option value="">-- Select --</option>
                  <option value="ProscribedPersons">Proscribed Persons</option>
                  <option value="DeProscribedPersons">De-Proscribed Persons</option>
                  <option value="Denotified">Denotified</option>
                </select>
              </div>

              <!--<div class="form-group col-md-4">
              <label>Active</label><br />
              <input type="checkbox" v-model="form.ACTIVE" />
            </div>-->

            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="closeModal">
              <span>Cancel</span>
            </button>
            <button type="button" class="btn btn-success" @click="addRow">
              {{ editingIndex !== null ? 'Update' : 'Add' }}
            </button>
          </div>

        </div>
      </div>
    </div>
    <!-- Import modal -->
    <div class="modal fade" id="importfile" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header bg-custom">
            <h4 class="modal-title">Import File</h4>
            <button type="button" class="close" @click="closeImportModal">
              <span style="color:white">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Upload File (.xlsx)</label>
                  <div class="input-group">
                    <input ref="importFileInput" style="padding:4px;height:auto;line-height:inherit;" type="file"
                           class="form-control" accept=".xlsx" @change="onImportFileUpload" />
                    <div class="input-group-append">
                      <button class="btn btn-sm btn-primary" type="button" @click="importData">Import File</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label>Partner Type <span class="text-danger">*</span></label>
                <v-select placeholder="--Select--" label="Title" :options="partnerTypes" v-model="importPartnerTypeID" :reduce="x=>x.ID" />
              </div>
              <div class="form-group col-md-4">
                <label>Status <span class="text-danger">*</span></label>
                <select class="form-control" v-model="importStatus">
                  <option value="">-- Select --</option>
                  <option value="ProscribedPersons">Proscribed Persons</option>
                  <option value="DeProscribedPersons">De-Proscribed Persons</option>
                  <option value="Denotified">Denotified</option>
                </select>
              </div>
            </div>

            <div class="table-responsive" style="max-height:400px;overflow-y:auto;">
              <table class="table table-bordered table-sm table-hover">
                <thead class="bg-custom">
                  <tr>
                    <th class="text-center">Sr.</th>
                    <th class="text-center">Name</th>
                    <th class="text-center">Father</th>
                    <th class="text-center">CNIC</th>
                    <th class="text-center">Province</th>
                    <th class="text-center">District</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in proscribedList" :key="ind">
                    <td class="text-center">{{ ind + 1 }}</td>
                    <td>{{ item.Name }}</td>
                    <td>{{ item.Father }}</td>
                    <td>{{ item.CNIC }}</td>
                    <td>{{ item.Province }}</td>
                    <td>{{ item.District }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-success" v-if="fileImported" @click="saveImport">Save</button>
            <button type="button" class="btn btn-warning" v-if="proscribedList.length" @click="clearImportData">Clear Data</button>
            <button type="button" class="btn btn-danger" @click="closeImportModal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  const emptyForm = () => ({
    BAL_ID: 0,
    PTR_ID: '',
    CLIENT_NAME: '',
    FATHERNAME: '',
    CNIC_NO: '',
    PVN_ID: '',
    CTY_ID: '',
    BLACK_LIST_BY: '',
    SECP_EMAIL_DATE: '',
    STATUS: '',
    //ACTIVE: false,
  });

  export default {
    data() {
      return {
        groupId: 0,

        mainForm: {
          SRO_NO: '',
          DATE_OF_SCR: new Date().toISOString().split('T')[0],
        },

        form: emptyForm(),

        editingIndex: null,

        detailList: [],

        states: [],
        cities: [],
        partnerTypes: [],
        modalInstance: null,

        importModalInstance: null,
        proscribedList: [],
        fileImported: false,
        importFile: null,
        importPartnerTypeID: '',
        importStatus: '',
      };
    },
    mounted() {
      this.modalInstance = new bootstrap.Modal(document.getElementById('clientModal'), { backdrop: 'static', keyboard: false });
      this.importModalInstance = new bootstrap.Modal(document.getElementById('importfile'), { backdrop: 'static', keyboard: false });
    },

    created() {
      this.loadPartnerTypes();
      this.pageload();
    },

    methods: {

      pageload() {
        const params = new URLSearchParams(window.location.search);
        const groupId = parseInt(params.get('groupId') || '0');
        const id = parseInt(params.get('id') || '0');
        window.history.replaceState({}, document.title, window.location.href.split('?')[0]);
        this.fetchStatesOnLoad(() => {
          if (groupId > 0) {
            this.loadGroup(groupId);
          } else if (id > 0) {
            this.loadSingleRecord(id);
          }
        });
      },
      loadPartnerTypes() {
        axios.get('/api/UICApi/loadPartnerTypes')
          .then(res => {
            if (res.data.status) {
              this.partnerTypes = res.data.partnerTypes || [];
            }
          })
          .catch(err => console.error(err));
      },
      loadGroup(groupId) {
        startReq();
        axios.get('/api/UICApi/pageloadBlockAccountsClientGroup?groupId=' + groupId)
          .then(res => {
            endReq();
            if (res.data.status && res.data.list && res.data.list.length) {
              const first = res.data.list[0];
              this.groupId = groupId;
              this.mainForm.SRO_NO = first.SRO_NO || '';
              this.mainForm.DATE_OF_SCR = first.DATE_OF_SCR ? first.DATE_OF_SCR.split('T')[0] : '';

              this.detailList = res.data.list.map(item => ({
                BAL_ID: item.BAL_ID,
                PTR_ID: item.PTR_ID,
                PTR_TYPE: item.PTR_TYPE,
                CLIENT_NAME: item.CLIENT_NAME,
                FATHERNAME: item.FATHERNAME,
                CNIC_NO: item.CNIC_NO,
                PVN_ID: item.PVN_ID,
                CTY_ID: item.CTY_ID,
                SRO_NO: item.SRO_NO,
                DATE_OF_SCR: item.DATE_OF_SCR ? item.DATE_OF_SCR.split('T')[0] : '',
                SECP_EMAIL_DATE: item.SECP_EMAIL_DATE ? item.SECP_EMAIL_DATE.split('T')[0] : '',
                BLACK_LIST_BY: item.BLACK_LIST_BY,
                STATUS: item.STATUS,
                //ACTIVE: item.ACTIVE === true,
              }));
            }
          })
          .catch(err => { endReq(); console.error(err); });
      },

      loadSingleRecord(id) {
        startReq();
        axios.get('/api/UICApi/pageloadBlockAccountsClient?id=' + id)
          .then(res => {
            endReq();
            const d = res.data.data;
            if (!d) return;
            this.partnerTypes = res.data.partnerTypes || [];
            this.groupId = d.GROUP_ID || 0;
            this.mainForm.SRO_NO = d.SRO_NO || '';
            this.mainForm.DATE_OF_SCR = d.DATE_OF_SCR ? d.DATE_OF_SCR.split('T')[0] : '';

            this.detailList = [{
              BAL_ID: d.BAL_ID,
              PTR_ID: d.PTR_ID,
              PTR_TYPE: d.PTR_TYPE,
              CLIENT_NAME: d.CLIENT_NAME,
              FATHERNAME: d.FATHERNAME,
              CNIC_NO: d.CNIC_NO,
              PVN_ID: d.PVN_ID,
              CTY_ID: d.CTY_ID,
              SRO_NO: d.SRO_NO,
              DATE_OF_SCR: d.DATE_OF_SCR ? d.DATE_OF_SCR.split('T')[0] : '',
              SECP_EMAIL_DATE: d.SECP_EMAIL_DATE ? d.SECP_EMAIL_DATE.split('T')[0] : '',
              BLACK_LIST_BY: d.BLACK_LIST_BY,
              STATUS: d.STATUS,
              //ACTIVE: d.ACTIVE === true,
            }];

            if (d.PVN_ID) this.fetchCitiesById(d.PVN_ID);
          })
          .catch(err => { endReq(); console.error(err); });
      },

      fetchStatesOnLoad(callback) {
        axios.get('/api/UICApi/loadStates?countryId=125')
          .then(res => {
            this.states = res.data.states || [];
            if (callback) callback();
          })
          .catch(() => { if (callback) callback(); });
      },

      fetchCities() {
        this.form.CTY_ID = '';
        this.cities = [];
        if (!this.form.PVN_ID) return;
        this.fetchCitiesById(this.form.PVN_ID);
      },

      fetchCitiesById(pvnId) {
        axios.get('/api/UICApi/loadCities?stateId=' + pvnId)
          .then(res => { this.cities = res.data.cities || []; })
          .catch(err => console.error(err));
      },
      getStatusText(status) {
        switch (status) {
          case 'ProscribedPersons':
            return 'Proscribed Person';

          case 'DeProscribedPersons':
            return 'De-Proscribed Person';

          case 'Denotified':
            return 'Denotified';

          default:
            return '';
        }
      },
      openModal(index) {

        if (!this.mainForm.SRO_NO || !this.mainForm.DATE_OF_SCR) {
          toastr.warning('Please enter SRO NO and Date first.');
          return;
        }

        if (index !== null && index >= 0) {

          this.editingIndex = index;

          const item = this.detailList[index];

          this.form = {
            BAL_ID: item.BAL_ID,
            PTR_ID: item.PTR_ID,
            PTR_TYPE: item.PTR_TYPE,
            CLIENT_NAME: item.CLIENT_NAME,
            FATHERNAME: item.FATHERNAME,
            CNIC_NO: item.CNIC_NO,
            PVN_ID: item.PVN_ID,
            CTY_ID: item.CTY_ID,
            BLACK_LIST_BY: item.BLACK_LIST_BY,
            SECP_EMAIL_DATE: item.SECP_EMAIL_DATE,
            STATUS: item.STATUS,
            //ACTIVE: item.ACTIVE,
          };

          if (item.PVN_ID) {
            this.fetchCitiesById(item.PVN_ID);
          }

        } else {

          this.editingIndex = null;
          this.form = emptyForm();
          this.cities = [];
        }

        this.modalInstance.show();
      },

      closeModal() {
        this.modalInstance.hide();
        this.form = emptyForm();
        this.editingIndex = null;
        this.cities = [];
      },
      addRow() {

        if (!this.form.CLIENT_NAME || !this.form.FATHERNAME || !this.form.CNIC_NO || !this.form.STATUS) {
          toastr.warning('Please fill Name, Father Name, CNIC and Status.');
          return;
        }

        const row = {
          BAL_ID: this.form.BAL_ID,
          PTR_ID: this.form.PTR_ID,
          PTR_TYPE: this.partnerTypes.find(x => x.ID === this.form.PTR_ID).Title || '',
          CLIENT_NAME: this.form.CLIENT_NAME,
          FATHERNAME: this.form.FATHERNAME,
          CNIC_NO: this.form.CNIC_NO,
          PVN_ID: this.form.PVN_ID,
          CTY_ID: this.form.CTY_ID,
          SRO_NO: this.mainForm.SRO_NO,
          DATE_OF_SCR: this.mainForm.DATE_OF_SCR,
          BLACK_LIST_BY: this.form.BLACK_LIST_BY,
          SECP_EMAIL_DATE: this.form.SECP_EMAIL_DATE,
          STATUS: this.form.STATUS,
          //ACTIVE: this.form.ACTIVE,
        };

        if (this.editingIndex !== null) {

          this.$set(this.detailList, this.editingIndex, row);

          toastr.success('Entry Updated Successfully');

        } else {

          this.detailList.push(row);

          toastr.success('Entry Added Successfully');
        }

      //  this.closeModal();
      },

      editRow(index) {
        this.openModal(index);
      },

      deleteRow(index) {
        const item = this.detailList[index];
        const vm = this;
        Swal.fire({
          title: 'Are you sure?',
          text: 'Delete entry for ' + item.CLIENT_NAME + '?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Yes, Delete!',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            if (item.BAL_ID > 0) {
              startReq();
              axios.post('/api/UICApi/DeleteBlockAccountsClient', {
                BalId: item.BAL_ID
              })
                .then(res => {
                  endReq();
                  if (res.data.status) {
                    vm.detailList.splice(index, 1);
                    Swal.fire({
                      icon: 'success',
                      title: 'Deleted!',
                      text: 'Entry deleted successfully.',
                      timer: 1500,
                      showConfirmButton: false
                    });
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: res.data.msg
                    });
                  }
                })
                .catch(() => {
                  endReq();
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error deleting entry.'
                  });
                });
            } else {
              vm.detailList.splice(index, 1);
              Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: 'Entry removed successfully.',
                timer: 1500,
                showConfirmButton: false
              });
            }
          }
        });
      },

      submitForm() {
        if (!this.mainForm.SRO_NO || !this.mainForm.DATE_OF_SCR) {
          toastr.warning('Please fill SRO NO and Date.');
          return;
        }
        if (this.detailList.length === 0) {
          toastr.warning('Please add at least one entry.');
          return;
        }

        startReq();
        axios.post('/api/UICApi/SaveBlockAccountsClient', {
          GroupId: this.groupId,
          BlockAccountClients: this.detailList,
        })
          .then(res => {
            endReq();
            if (res.data.status) {
              if (res.data.groupId) this.groupId = res.data.groupId;
              toastr.success('Saved Successfully');
            } else {
              toastr.error('Failed: ' + res.data.msg);
            }
          })
          .catch(err => {
            endReq();
            console.error(err);
            toastr.error('An error occurred while saving.');
          });
      },
      openImportModal() {
        if (!this.mainForm.SRO_NO || !this.mainForm.DATE_OF_SCR) {
          toastr.warning('Please enter SRO NO and Date first.');
          return;
        }
        if (this.detailList.some(x => !(x.BAL_ID > 0))) {
          toastr.warning('Please save your current entries first, the list reloads after import.');
          return;
        }
        this.importModalInstance.show();
      },

      closeImportModal() {
        this.importModalInstance.hide();
        this.clearImportData();
        this.importPartnerTypeID = '';
        this.importStatus = '';
      },

      clearImportData() {
        this.proscribedList = [];
        this.fileImported = false;
        this.importFile = null;
        if (this.$refs.importFileInput) this.$refs.importFileInput.value = '';
      },

      onImportFileUpload(event) {
        const file = event.target.files ? event.target.files[0] : null;
        if (!file) return;

        if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          toastr.error('Invalid file, only Excel (.xlsx) allowed');
          event.target.value = '';
          this.importFile = null;
          return;
        }
        const reader = new FileReader();
        reader.onload = e => { this.importFile = e.target.result; };
        reader.readAsDataURL(file);
      },

      importData() {
        if (!this.importFile) {
          toastr.error('No file uploaded');
          return;
        }
        startReq();
        axios.post('/api/UICApi/ImportBlockpersons', { File: this.importFile })
          .then(res => {
            endReq();
            if (res.data.status) {
              toastr.success('File Uploaded');
              this.proscribedList = res.data.data || [];
              this.fileImported = this.proscribedList.length > 0;
            } else {
              toastr.error(res.data.msg);
              this.proscribedList = [];
              this.fileImported = false;
            }
            this.importFile = null;
            if (this.$refs.importFileInput) this.$refs.importFileInput.value = '';
          })
          .catch(err => {
            endReq();
            console.error(err);
            this.proscribedList = [];
            this.fileImported = false;
          });
      },

      saveImport() {
        if (!this.importPartnerTypeID) { toastr.error('Select Partner Type'); return; }
        if (!this.importStatus) { toastr.error('Select Status'); return; }

        startReq();
        axios.post('/api/UICApi/SaveBlockpersons', {
          BlockAccountList: this.proscribedList,
          PartnerTypeID: this.importPartnerTypeID,
          Status: this.importStatus,
          GroupId: this.groupId,
          SroNo: this.mainForm.SRO_NO,
          DateOfScr: this.mainForm.DATE_OF_SCR
        })
          .then(res => {
            endReq();
            if (res.data.status) {
              toastr.success(res.data.msg);
              this.groupId = res.data.groupId;
              this.closeImportModal();
              this.loadGroup(this.groupId); 
            } else {
              toastr.error(res.data.msg);
            }
          })
          .catch(err => { endReq(); console.error(err); toastr.error('An error occurred while saving.'); });
      },
    },
  };
</script>

<style scoped>
  .mt-3 {
    margin-top: 1rem;
  }

  .ml-1 {
    margin-left: 0.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/BlockAccountsClient.vue